import { createFileRoute } from "@tanstack/react-router";
import { PriceDevelopmentSection } from "./-components/PriceDevelopmentSection";
import { PropertyTypeNotice } from "./-components/PropertyTypeNotice";
import { PropertyUnitList } from "./-components/PropertyUnitList/PropertyUnitList";

export const Route = createFileRoute(
  "/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/sales-prices/{-$bfeNumber}",
)({
  component: SalesPricesPage,
  loader: async ({ context: { i18n } }) => {
    await i18n.loadNamespaces("sales-prices");

    const title = i18n.t("sales-prices:meta.title");

    return { meta: { title } };
  },
  head: async (context) => {
    return {
      meta: [
        {
          title: context.loaderData?.meta.title,
        },
      ],
    };
  },
});

function SalesPricesPage() {
  const { accessAddressId, placeId, bfeNumber } = Route.useParams();

  return (
    <div className="flex flex-col gap-6">
      <PropertyTypeNotice
        accessAddressId={accessAddressId}
        placeId={placeId}
      />
      <PriceDevelopmentSection
        accessAddressId={accessAddressId}
        placeId={placeId}
        bfeNumber={bfeNumber}
      />
      <PropertyUnitList
        accessAddressId={accessAddressId}
        placeId={placeId}
        bfeNumber={bfeNumber}
      />
    </div>
  );
}
